import React from 'react';
import { motion } from 'framer-motion';

function Navbar() {
    return (
        <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-sm">
            <div className="md:max-w-[80vw] mx-auto">
                <motion.div
                    className="py-4"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <div className="group inline-flex items-center space-x-2 text-xl font-mono">
                        <span className="text-primary">&lt;/&gt;</span>
                        <span className="bg-gradient-to-r from-primary to-neon bg-clip-text text-transparent group-hover:animate-glow">
                            fccview.dev
                        </span>
                    </div>
                </motion.div>
            </div>
        </header>
    );
}

export default Navbar; 